export default "__VITE_ASSET__Bc28aEVJ__"